import { UserAction, UserTypes } from './users.actions';

export enum Language {
  Norwegian = 'nb',
  English = 'gb'
}

export type UsersState = Readonly<{
  language: Language;
}>;

export const initialState: UsersState = {
  language: Language.Norwegian
};

const usersReducer = (state: UsersState = initialState, action: UserAction) => {
  switch (action.type) {
    case UserTypes.ChangeLanguage:
      return { ...state, language: action.language };
    default:
      return state;
  }
};

export default usersReducer;
